import { ThemeProvider } from "@emotion/react";
import { Box, Modal } from "@mui/material";
import Grid from "@mui/material/Grid";
import { createTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import ImageButton from "components/atoms/Button/ImageButton";
import SignButton from "components/atoms/Button/SignButton";
import * as React from "react";
// import { useNavigate } from "react-router-dom";

const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});


const MainModal = styled(Modal)(({ theme }) => ({
  height: '95vh',
  maxWidth: '425px',
  margin: 'auto',
  overflowY: 'auto',
  borderRadius: '50px',
  boxShadow: theme.shadows[10]
}));

const Body = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  paddingBottom: "50px",
  width: "100%",
}));

const ContentGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  paddingLeft: "57px",
  paddingRight: "57px",
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: "#ffffff",
  fontSize: "25px",
  fontWeight: "bold",
  paddingBottom: "26px",
}));
const ParaText = styled(TitleText)(({ theme }) => ({
  paddingBottom: "40px",
  fontSize: "16px",
  color: "#c1c1c1",
  fontWeight: "normal",
}));
const ConnectWalletBody = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: '#292739',
  borderRadius: '25px',
  padding: '40px 20px',
  color: '#fff',
  maxWidth: '500px',
  width: '100%',
  boxSizing: 'border-box',
  boxShadow: theme.shadows[10]
}));

const WalletCont = styled(Box)(({ theme }) => ({
  displat: 'flex',
  justifyContent: 'center',
  margin: '20px auto',
  maxWidth: '250px',
}));

const MetaMaskCard = styled(Box)(({ theme }) => ({
  displat: 'flex',
  alignItems: 'center',
  padding: '20px 15px',
  borderRadius: '10px',
  backgroundImage: 'linear-gradient(90deg, #ff5e00, #ffff2e)',
  '& span': {
    fontWeight: 'bolder'
  },
  '&:hover': {
    cursor: 'pointer'
  }
}));

interface ISignInProps {
  handleConnectWallet: () => void;
}

const SignIn: React.FC<ISignInProps> = ({ handleConnectWallet }) => {
  const illustration = require('assets/illustration.png');
  // const history = useNavigate();

  const [showWalletModal, setShowWalletModal] = React.useState<boolean>(false);


  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <MainModal open={true} className="scrollbar-hidden">
          <Body>
            <ContentGrid sx={{ justifyContent: "center", padding: "unset" }}>
              <img src={illustration} alt={"img"} style={{ width: "100%", height: "229px" }} />
            </ContentGrid>
            <ContentGrid sx={{ paddingTop: "50px" }}>
              <TitleText>Sign In</TitleText>
            </ContentGrid>
            <ContentGrid>
              <ParaText>Welcome back to Buku!</ParaText>
            </ContentGrid>
            <ContentGrid sx={{ justifyContent: "center", paddingBottom: "45px", paddingX: "80px" }}>
              <div onClick={() => setShowWalletModal(true)} style={{ width: "100%" }}>
                <SignButton text={"Connect Wallet"} color={"yellow"} />
              </div>
            </ContentGrid>
            <ContentGrid sx={{ justifyContent: "center" }}>
              <ParaText style={{ paddingBottom: "20px" }}>
                Or sign in with
              </ParaText>
            </ContentGrid>
            <ContentGrid
              sx={{
                justifyContent: "center",
                paddingBottom: "58px",
                gap: "5px",
                height: "110px",
              }}
            >
              <ImageButton type={"google"} />
              <ImageButton type={"twitter"} />
            </ContentGrid>
            <ContentGrid sx={{ justifyContent: "center" }}>
              <Typography component={"span"} sx={{ color: "#c1c1c1" }}>
                Don’t have an account yet?
                <span
                  style={{ color: "#DDB930" }}
                // onClick={() => history("/signup")}
                >
                  &nbsp;&nbsp;
                  Sign Up
                </span>
              </Typography>
            </ContentGrid>
          </Body>
        </MainModal>

        <Modal
          open={showWalletModal}
          onClose={() => setShowWalletModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ConnectWalletBody>
            <Typography variant="h3" component="h2" textAlign={"center"}>
              Select a wallet
            </Typography>
            <Typography textAlign={"center"} sx={{ my: 3 }}>
              By connection your wallet you agree to our <br/>
              <strong>Terms of Service</strong> and our <strong>Privacy Policy</strong>
            </Typography>

            <WalletCont>
              <MetaMaskCard onClick={()=>handleConnectWallet()}>
                <span>MetaMask</span>
              </MetaMaskCard>
            </WalletCont>
          </ConnectWalletBody>
        </Modal>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default SignIn;
